__turbopack_context__.v({
  "description": "intro-module-scss-module___57d5a__description",
  "intro": "intro-module-scss-module___57d5a__intro",
  "introAnimatedTitle": "intro-module-scss-module___57d5a__introAnimatedTitle",
});
